import {
	type Action,
	Scope,
	type UserAccessProfile,
} from "@pilatestime/shared-types";
import { useSuspenseQuery } from "@tanstack/react-query";
import { fetchAccessProfileQueryOptions } from "@/api/accessProfile";
import { Route as OrgRoute } from "@/routes/_auth/app/_app/org/$orgId";

// Local ResourceContext type for frontend gating
export type ResourceContext = { scope: Scope.ORG };

export function can(profile: UserAccessProfile, action: Action): boolean {
	// Client-side fast check mirrors backend logic.
	// Note: Server is source of truth; client is for gating UI.
	// Check if user has the required permission at org level
	return profile.grants.some(
		(g) => g.action === action && g.scope === Scope.ORG,
	);
}

export function getAllowedEstablishments(
	profile: UserAccessProfile,
	action: Action,
): "ALL" | string[] {
	return profile.allowedEstablishmentIdsByAction[action] ?? [];
}

export function useCan() {
	const { userId, token, orgId } = OrgRoute.useLoaderData();
	const { data: profile } = useSuspenseQuery(
		fetchAccessProfileQueryOptions(userId, token, orgId),
	);
	return (action: Action) => can(profile, action);
}
